import { SVGProps, Ref, forwardRef } from 'react'
const SvgLink = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.765 9.022a4.471 4.471 0 0 0-1.296-3.416l-1.06-1.061a4.5 4.5 0 1 0-6.364 6.364l1.06 1.06a4.475 4.475 0 0 0 3.417 1.296M15.476 11.735a4.47 4.47 0 0 1 3.417 1.295l1.06 1.06a4.5 4.5 0 1 1-6.363 6.365l-1.06-1.06a4.473 4.473 0 0 1-1.296-3.418M8.287 8.787l7.425 7.425"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgLink)
export default ForwardRef
